import React, {Component} from "react";
import SectionMenu from "../../components/SectionMenu";
import AccountHeader from "../shared/AccountHeader";
import AccessList from "../shared/AccessList";
import DeliveryList from "../shared/DeliveryList";
import AddressList from "../shared/AddressList";
import OrderList from "../shared/OrderList";
import CartList from "../shared/CartList";
import CreditCardList from "../shared/CreditCardList";
import ChargesList from "../shared/ChargesList";
import SubscriptionList from "../shared/SubscriptionList";
import AccountNotifications from "../shared/AccountNotifications";
import EmptyStatus from "../../components/EmptyStatus";
import {fromJS} from "immutable";
import "./AccountDetails.css";
import {cx} from "../../lib/ClassSet";

const menuItems = fromJS([
  { id: "subscriptions", label: "Subscriptions"},
  { id: "cart", label: "Cart"},
  { id: "orders", label: "Order History"},
  { id: "deliveries", label: "Deliveries"},
  { id: "paymentMethods", label: "Payment Methods"},
  { id: "charges", label: "Charges"},
  { id: "notifications", label: "Notifications"},
  { id: "access", label: "Access"}
])

class AccountDetails extends Component {

  constructor(props) {
    super(props);
    this.handleMenuChange = this.handleMenuChange.bind(this);
    this.state = {
      selectedMenuId: "subscriptions"
    }
  }

  render() {
    const classes = cx({
      "AccountDetails": true,
      "deleted": this.props.deleted,
    })

    const name = this.props.deleted
      ? this.props.name + " -- DELETED"
      : this.props.name;

    return (
      <div className={classes}>
        <AccountHeader
          name={name}
          accountId={this.props.accountId}
          accountType=""
          onSelect={this.props.onSelect}
          selected={this.props.selected}
          vip={this.props.vip}
          />
        <SectionMenu 
          items={menuItems} 
          selectedId={this.state.selectedMenuId} 
          onChange={this.handleMenuChange} 
          />
        <div className="views">
          {this.renderSubscriptions()}
          {this.renderCart()}
          {this.renderOrderHistory()}
          {this.renderDeliveries()}
          {this.renderCards()}
          {this.renderCharges()}
          {this.renderNotifications()}
          {this.renderAccessList()}
        </div>
      </div>
    )
  }

  renderSubscriptions() {
    if (this.state.selectedMenuId !== "subscriptions") return null;
    return <SubscriptionList
            accountId={this.props.accountId}
            />
  }

  renderOrderHistory() {
    if (this.state.selectedMenuId !== "orders") return null;
    return <OrderList
            accountId={this.props.accountId}
            />    
  }

  renderDeliveries() {
    if (this.state.selectedMenuId !== "deliveries") return null;
    return <DeliveryList accountId={this.props.accountId} /> 
  }

  renderCards() {
    if (this.state.selectedMenuId !== "paymentMethods") return null;
    return <CreditCardList accountId={this.props.accountId} /> 
  }

  renderCharges() {
    if (this.state.selectedMenuId !== "charges") return null;
    return <ChargesList accountId={this.props.accountId} /> 
  }

  renderBillingDetails() {
    if (this.state.selectedMenuId !== "billingDetails") return null;
    return <EmptyStatus status="Not implemented" />
  }

  renderCart() {
    if (this.state.selectedMenuId !== "cart") return null;
    return <CartList
              accountId={this.props.accountId}
              />
  }

  renderAddresses() {
    if (this.state.selectedMenuId !== "addresses") return null;
    return <AddressList 
              accountId={this.props.accountId} 
              onAddressClick={this.props.onAddressClick}
              />
  }

  renderNotifications() {
    if (this.state.selectedMenuId !== "notifications") return null;
    return <AccountNotifications accountId={this.props.accountId} />
  }

  renderAccessList() {
    if (this.state.selectedMenuId !== "access") return null;
    return <AccessList accountId={this.props.accountId} />
  }

  handleMenuChange(id) {
    this.setState({"selectedMenuId": id});
  }

}


AccountDetails.defaultProps = {
  name: "Personal",
  accountType: "personal",
  accountId: "52d76ac9f9324c35b0cd7ffd313d490c",
  selected: false
}

export default AccountDetails;